import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_6_3_5,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-6-3-5',
    templateUrl: './exemption_6_3_5.component.html',
    styleUrls: ['./exemption_6_3_5.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_6_3_5Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_6_3_5;

  portVisitUtils = PortvisitUtils;
  dangerousGoods?: DangerInformation;

  firstVessel: Vessel;
  secondVessel: Vessel;
  thirdVessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  resetVesselInfoFirst() {
    this.firstVessel = null;
    this.exemption.firstVesselENI = '';
    this.exemption.firstVesselIMO = '';
    this.exemption.firstVesselNameENI = '';
    this.exemption.firstVesselNameIMO = '';
    this.exemption.firstVesselFrom = '';
    this.exemption.firstVesselTo = '';

    if (!this.exemption.firstVesselType) {
      this.exemption.secondVesselType = '';
    }
  }

  resetVesselInfoSecond() {
    this.secondVessel = null;
    this.exemption.secondVesselENI = '';
    this.exemption.secondVesselIMO = '';
    this.exemption.secondVesselNameENI = '';
    this.exemption.secondVesselNameIMO = '';
    this.exemption.secondVesselFrom = '';
    this.exemption.secondVesselTo = '';

    if (!this.exemption.secondVesselType) {
      this.exemption.thirdVesselType = '';
    }
  }

  resetVesselInfoThird() {
    this.thirdVessel = null;
    this.exemption.thirdVesselENI = '';
    this.exemption.thirdVesselIMO = '';
    this.exemption.thirdVesselNameENI = '';
    this.exemption.thirdVesselNameIMO = '';
    this.exemption.thirdVesselFrom = '';
    this.exemption.thirdVesselTo = '';
  }
}

